import DashboardContainer from './DashboardOverview';

const FinanceDashboard = () => {
  return <DashboardContainer />;
};

export default FinanceDashboard;
